export default "__VITE_ASSET__07e49c0c__"